<template>
  <div
    id="container-pasta-criada"
    class="container"
  >
    <div class="col">
      <el-dialog
        :visible.sync="dialogTableVisible"
        :before-close="handleClose"
      >
        <div>
          <div class="col">
            <el-tag size="medium">
              recomendado
            </el-tag>
          </div>
          <el-button
            class="item"
            @click="javascript"
          >
            JS
          </el-button>
          <el-button
            class="item"
            @click="iframe"
          >
            Iframe
          </el-button>
          <el-button
            class="item"
            @click="link"
          >
            Link
          </el-button>
        </div>
        <el-divider />
        <h2 class="ant-typography">
          {{ embedCode.name }}
        </h2>
        <div class="col">
          <pre>{{ embedName }}</pre>
          <div class="row justify-content-end">
            <div class="col-1">
              <i
                class="el-icon-document-copy"
                @click="copiarTexto()"
              />
            </div>

          </div>

          <div
            id="content___1YRKM"
            class="player-card-modal-textarea "
          >
            <textarea
              id="texto"
              readonly=""
              class="ant-input"
            >
             {{ embedCode.embed }}
           </textarea>
          </div>
        </div>
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button @click="closeModal">Cancel</el-button>
        </span>
      </el-dialog>
    </div>
    <div>
      <div
        v-if="showModal"
        class="modal-background animate__fadeInDownBig"
        @click="showModal = false"
      >
        <div class="modal-content">
          <div
            v-if="showModal"
            class="embed-responsive embed-responsive-16by9"
          >
            <iframe
              class="embed-responsive-item"
              :src="UrlVideo"
              allowfullscreen
            />
          </div>
        </div>
      </div>
    </div>
    <ul
      v-for="item of vsls"
      :key="item.id"
      class="players___26VY9 hvr-glow "
      @click="video(item)"
    >
      <li
        class="player-card___2Fvfg"
        draggable="true"
        style="opacity: 1;"
        @click="video(item)"
      >
        <button
          class="player-card--checkbox___27L9W"
          @click.stop
        >
          <label class="ant-checkbox-wrapper content--zindex">
            <span class="ant-checkbox">
              <input
                id="check1"
                v-model="item.is_selected"
                type="checkbox"
                class="ant-checkbox-input"
                value=""
                name="check1"
                :true-value="true"
                :false-value="false"
                @input="handleChecked(item)"
              >
            </span>
          </label>
        </button>
        <div
          class="ant-row ant-row-no-wrap ant-row-middle player-card--content___D1qZG"
          style="row-gap: 0px;"
        >
          <div
            class="ant-col player-card--thumb___35WZM"
            style="flex: 1 1 auto; min-width: 0px;"
            @click="video(item)"
          >
            <div class="player-card-thumb-name___2WjVQ">
              <div class="player-card-thumb___361GV">
                <div class="player-card-thumb___Erlrt">
                  <img
                    class="player-card-thumb--image___1cZXg"
                    alt="mentoria_jornada_rico_por_opcao"
                    :src="item.vsl_frame"
                  >
                  <span class="ant-tag player-card-thumb--duration-tag___38VC6">{{ item.vsl_tempoVideo }}s</span>
                  <div
                    class="player-card-thumb--play___1GcpI"
                    @click.stop="playVideo(item)"
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="#FFF"
                    >
                      <g clip-path="url(#clip0_466_2550)">
                        <path
                          d="M23.14 10.608L2.253 0.164C2.01554 0.0459508 1.75189 -0.00957541 1.48699 0.00267244C1.22209 0.0149203 0.964693 0.0945373 0.73914 0.233994C0.513586 0.373451 0.327334 0.568137 0.197996 0.799642C0.0686589 1.03115 0.000511817 1.29182 0 1.557L0 22.444C0.000407617 22.7092 0.068505 22.9699 0.197843 23.2014C0.327181 23.433 0.513479 23.6276 0.739092 23.767C0.964706 23.9064 1.22217 23.9859 1.4871 23.998C1.75202 24.0101 2.01565 23.9543 2.253 23.836L23.14 13.393C23.3986 13.2637 23.616 13.0649 23.768 12.8189C23.9199 12.573 24.0004 12.2896 24.0004 12.0005C24.0004 11.7114 23.9199 11.428 23.768 11.1821C23.616 10.9361 23.3986 10.7373 23.14 10.608Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_466_2550">
                          <rect
                            width="24"
                            height="24"
                            fill="white"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </div>
              </div>
              <div
                class="player-card-thumb-name--info___21UGr"
                @click.stop
              >
                <div
                  class="player-card-name___2r4hW"
                  @click="video(item)"
                >
                  <strong
                    :id="'strong' + item.id"
                    @click.stop
                  >{{ item.vsl_name }}</strong>

                  <input
                    :id="'input' + item.id"
                    v-model="item.vsl_name"
                    data-tourTarget="edicaoNomeArquivo"
                    style="width: 250px"
                    class="border border-1"
                    hidden
                    @click.stop
                  >
                  <span
                    :id="'icone-editar' + item.id"
                    role="img"
                    aria-label="edit"
                    tabindex="-1"
                    class="anticon anticon-edit player-card-name--edit_icon___3cbkf"
                    @click.stop="aparecerEdição(item.id);"
                  >

                    <span
                      role="img"
                      aria-label="edit"
                      tabindex="-1"
                      class="anticon anticon-edit player-card-name--edit_icon___2Yf9-"
                    >
                      <svg
                        viewBox="64 64 896 896"
                        focusable="false"
                        data-icon="edit"
                        width="1em"
                        height="1em"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          d="M880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32zm-622.3-84c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9z"
                        />
                      </svg>
                    </span>

                  </span>
                  <span
                    :id="'botao-salvar' + item.id"
                    role="img"
                    hidden
                    @click.stop="salvarEdicão(item)"
                  >
                    <feather-icon
                      icon="CheckIcon"
                      color="green"
                    />
                  </span>
                </div>
                <div
                  class="player-card-thumb-orientation"
                  style=" display: flex; align-items: center; gap: 4px;"
                >
                  <feather-icon
                    :icon="item.orientation === 'Vertical' ? 'SmartphoneIcon' : 'MonitorIcon'"
                    size="13"
                    :stroke="item.orientation === 'Vertical' ? '#52c41a' : '#1890ff'"
                  />
                  <span style="font-size: 12px; color: #888;">
                    {{ item.orientation || 'Horizontal' }}
                  </span>
                </div>
                <div
                  class="player-card-thumb-name--info_date___97-MJ"
                  @click="video(item)"
                >
                  <span
                    class="ant-typography ant-typography-ellipsis ant-typography-single-line ant-typography-ellipsis-single-line"
                  >{{
                    item.vsl_dt_add
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <div
            class="ant-col player-card--info___1ux6J "
            style="flex: 1 1 auto; min-width: 0px;"
            @click.stop
          >
            <a class="player-card-views___sZ32Z">
              <b-badge
                variant="light-primary"
                @click.stop="$router.push({ name: 'analytics', params: { vslId: item.id } })"
              >
                {{ item.qtde_load }} Visualizações
              </b-badge>
            </a>
            <div
              class="player-card-embed___3e5aX"
              @click.stop="embed(item); dialogTableVisible = true"
            >
              <span>
                <feather-icon
                  icon="CodeIcon"
                  size="18"
                  stroke="red"
                  class="mr-50"
                />
              </span>
            </div>

            <div class="align-self-center">
              <el-dropdown>
                <el-button
                  style=" border: none;"
                  type="button"
                  class="is-plain"
                >
                  <i class="el-icon-more" />
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <feather-icon
                      icon="EditIcon"
                      size="18"
                      stroke="red"
                      class="mr-50"
                    />
                    <span @click="editar(item.id)">Editar</span></el-dropdown-item>
                  <el-dropdown-item>
                    <feather-icon
                      icon="CodeIcon"
                      size="18"
                      stroke="red"
                      class="mr-50"
                    />
                    Embed
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <feather-icon
                      icon="PieChartIcon"
                      size="18"
                      stroke="red"
                      class="mr-50"
                    />
                    <span @click="$router.push({ name: 'analytics', params: { vslId: item.id } })">Analytics</span>
                  </el-dropdown-item>
                  <!-- <el-dropdown-item>Duplicar</el-dropdown-item> -->
                  <el-dropdown-item>
                    <feather-icon
                      icon="DownloadIcon"
                      size="18"
                      stroke="red"
                      class="mr-50"
                    />
                    <span @click="download(item)">Download</span></el-dropdown-item>
                  <el-dropdown-item>
                    <feather-icon
                      icon="TrashIcon"
                      size="18"
                      stroke="red"
                      class="mr-50"
                    />
                    <span @click="open(item)">Remover</span></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <!--          <a class="player-card&#45;&#45;details_link___imUBL" @click="video(item)" />-->
        </div>
      </li>
    </ul>
  </div>
</template>
<script>

import axios from 'axios'
import { VslService } from '@/services/Vsl'
import {
  BAlert, BLink, BCard, BCardText, BBadge,
} from 'bootstrap-vue'
import { mapActions } from 'vuex'
import { useApiAWS } from '@/composables/useApi'
import EmbedModal from '@/services/embedModal'
import { EventBus } from '@/main'
import Ripple from 'vue-ripple-directive'
import store from '@/store'

const apiAws = useApiAWS()
export default {
  components: {
    BBadge,
  },
  directives: {
    Ripple,
  },
  props: ['value'],
  data() {
    return {
      teste: {
        id: 0,
        vsl_name: 'teste',
        vsl_description: 'teste-video',
      },
      tableData: [
        {
          id: 0,
          name: 'teste',
          embed: 'teste-video',
        },
        {
          id: 1,
          name: 'teste',
          embed: 'teste-video',
        },
      ],
      UrlVideo: '',
      showModal: false,
      idVsl: {},
      vsl_frame: {},
      dialogTableVisible: false,
      folderVideoChecked: [],
      userData: JSON.parse(localStorage.getItem('userData')),
      VUE_APP_HOST_API_AWS_S3: process.env.VUE_APP_HOST_API_AWS_S3,
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND,
      vslId: this.$route.params.vslId,
      contentWidth: this.$store.state.appConfig.layout.contentWidth,
      loading: false,
      errorMessage: null,
      embedCode: '',
      embedName: '',
    }
  },
  computed: {
    vsls: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  nome: 'Videos',

  methods: {
    ...mapActions('Videos', ['listarVideos']),
    updatePrimeiroAcesso() {
      const date = new Date()
      date.setHours(date.getHours() - 3)
      fetch(`${this.VUE_APP_HOST_API_BACKEND}/updatePrimeiroAcesso`, {

        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: this.userData.id,
          user_data_primeiro_acesso: date.toISOString().slice(0, 19).replace('T', ' '),
        }),
      })
        .then(() => {
          const user = JSON.parse(localStorage.getItem('userData'))
          user.user_data_primeiro_acesso = date.toISOString().slice(0, 19).replace('T', ' ')
          localStorage.setItem('userData', JSON.stringify(user))
        })
    },
    async closeModal() {
      this.dialogTableVisible = false
      localStorage.removeItem('itemEmbed')
    },
    async javascript() {
      const embedName = 'Código JS'
      const embedModal = new EmbedModal()
      this.embedCode = await embedModal.embedModal(embedName)
    },
    async iframe() {
      const embedName = 'Código Iframe'
      const embedModal = new EmbedModal()
      this.embedCode = await embedModal.embedModal(embedName)
    },
    async link() {
      const embedName = 'Link'
      const item = JSON.parse(localStorage.getItem('itemEmbed'))
      let url = item.vsl_bucket_address || item.vsl_url || ''

      url = url
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .replace(/ /g, '')

      this.embedCode = {
        name: embedName,
        embed: url,
      }
    },
    handleClose(done) {
      done()
      localStorage.removeItem('itemEmbed')
    },
    playVideo(item) {
      this.UrlVideo = item.vsl_bucket_address
      this.showModal = true
    },
    copiarTexto() {
      const textoCopiado = document.getElementById('texto')
      textoCopiado.select()
      textoCopiado.setSelectionRange(0, 99999)
      document.execCommand('copy')
      this.$message({
        message: 'Código copiado para área de transferência',
        type: 'success',
      })
    },
    async embed(item) {
      localStorage.setItem('itemEmbed', JSON.stringify(item))
      const embedName = 'Código JS'
      const embedModal = new EmbedModal()
      this.embedCode = await embedModal.embedModal(embedName)
    },

    handleChecked(item) {
      this.$emit('selectVideoFolder', item)
    },
    forceFileDownload(response) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'file.mp4')
      document.body.appendChild(link)
      link.click()
    },
    download(item) {
      axios({
        method: 'get',
        url: item.vsl_bucket_address,
        responseType: 'arraybuffer',
      })
        .then(response => {
          this.forceFileDownload(response)
        })
        .catch(() => console.log('error occured'))
    },

    editar(item) {
      this.$router.push(`/player/${item}/customizacao`)
    },

    video(item) {
      this.$router.push(`/player/${item.id}`)
      EventBus.$emit('player', this.teste)
    },
    deletarThumb(item) {
      const options = {
        method: 'GET',
        url: `${this.VUE_APP_HOST_API_BACKEND}/tumb_vsl/${item}`,
      }
      axios.request(options).then(response => {
        const thumbInicio = response.data[0].tumb_key_name_start
        const thumbPausa = response.data[0].thumb_key_name_pausa
        const thumbFinal = response.data[0].thumb_key_name_end

        if (thumbInicio !== typeof undefined) {
          axios.request({
            method: 'DELETE',
            url: `${process.env.VUE_APP_HOST_API_AWS_S3}/`,
            params: { key: `${thumbInicio}` },
          }).then(response => {
            console.log('REPOSTA API AWS', response.data)
          }).catch(error => {
            console.error(error)
          })
        }
        if (thumbPausa !== typeof undefined) {
          axios.request({
            method: 'DELETE',
            url: `${process.env.VUE_APP_HOST_API_AWS_S3}/`,
            params: { key: `${thumbPausa}` },
          }).catch(error => {
            console.error(error)
          })
        }
        if (thumbFinal !== typeof undefined) {
          axios.request({
            method: 'DELETE',
            url: `${process.env.VUE_APP_HOST_API_AWS_S3}/`,
            params: { key: `${thumbFinal}` },
          }).catch(error => {
            console.error(error)
          })
        }
      }).catch(error => {
        console.error(error)
      })
    },
    deletarFrame(item) {
      const options = {
        method: 'DELETE',
        url: `${this.VUE_APP_HOST_API_AWS_S3}/`,
        params: { key: `Thumb_frame/thumb_frame-${item}.png` },
      }
      axios.request(options).catch(error => {
        console.error(error)
      })
    },
    async deletarAWS(item) {
      await apiAws.delete('/remover-folder', {
        params: {
          folder_key_name: item,
        },
      })
        .then(resp => {
          console.log('REMOVIDO PASTA COMPLETA DO VIDEO: ', resp)
        })
    },

    deleteVSL(vslId) {
      try {
        this.loading = true
        VslService.deleteVsl(vslId).then(response => {
          console.log(response)
          if (response) {
            this.listarVideos()
            // VslService.getALLVsls().then(response => {
            //   this.vsls = response.data;
            //   this.loading = false;
            // });
          }
        })
      } catch (error) {
        this.errorMessage = error
        this.loading = false
      }
    },
    open(item) {
      this.$confirm('Você tem certeza que deseja deletar esse video?', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'Deletar Videos',
      }).then(res => {
        if (res) {
          this.deletarAWS(item.vsl_key_name)
          this.deletarFrame(item.id)
          this.deletarThumb(item.id)
          this.deleteVSL(item.id)
        }
        this.$message({
          type: 'success',
          message: 'Deletado com sucesso',
        })
      }).catch(() => {
        console.log('cancelado')
        this.$message({
          type: 'info',
          message: 'Delete cancelado',
        })
      })
    },
    aparecerEdição(item) {
      console.log(`strong${item}`)
      const strong = document.getElementById(`strong${item}`)
      const input = document.getElementById(`input${item}`)
      const botaosalvar = document.getElementById(`botao-salvar${item}`)
      const iconeeditar = document.getElementById(`icone-editar${item}`)
      strong.setAttribute('hidden', '')
      iconeeditar.setAttribute('hidden', '')
      botaosalvar.removeAttribute('hidden')
      input.removeAttribute('hidden')
    },
    salvarEdicão(item) {
      const options = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: `{"vsl_name":"${item.vsl_name}"}`,
      }

      fetch(`${this.VUE_APP_HOST_API_BACKEND}/updateNameVSL/${item.id}`, options)
        .then(response => response.json())
        .then(response => {
          const strong = document.getElementById(`strong${item.id}`)
          const input = document.getElementById(`input${item.id}`)
          const botaosalvar = document.getElementById(`botao-salvar${item.id}`)
          const iconeeditar = document.getElementById(`icone-editar${item.id}`)
          input.setAttribute('hidden', '')
          botaosalvar.setAttribute('hidden', '')
          iconeeditar.removeAttribute('hidden')
          strong.removeAttribute('hidden')
          this.$message({
            type: 'success',
            message: 'Salvo com sucesso',
          })
        })
        .catch(err => console.error(err))
    },
  },

}
</script>
<style lang="scss" scoped>
@import '~animate.css/animate.min.css';
@import '@/assets/scss/modaEmbedCardVideos/modalEmbedPlayVideo.scss';
@import '@/assets/scss/card_videos/CardVideos.scss';

.folder-thumb-name {
  font-size: 4rem;
  color: #bf0000;
}

.hvr-glow {

  vertical-align: middle;
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-property: box-shadow;
  transition-property: box-shadow;
}

.hvr-glow:hover,
.hvr-glow:focus,
.hvr-glow:active {
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.407);
}

.el-dropdown {
  vertical-align: top;
}

.el-dropdown + .el-dropdown {
  margin-left: 15px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.item {
  margin: 20px;
  height: 100px;
  width: 110px;
}

.Scroll {
  height: 100px;
  overflow-y: scroll;

}

.el-icon-document-copy {
  padding: 1px;
  font-size: 25px;
  color: #2e2e2f;
  transition: color .15s linear;
}

#texto {
  color: black;
  height: 214px;
  font-size: large;
  font-family: Verdana;
}

.ant-input {
  box-sizing: border-box;
  margin: 0;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: "tnum", "tnum";
  position: relative;
  display: inline-block;
  width: 100%;
  min-width: 0;
  padding: 7px 11px;
  color: rgb(24 8 8 / 85%);
  font-size: 14px;
  line-height: 1.5715;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  transition: all .3s;
}
</style>
